import { Component, Event, EventEmitter, getAssetPath, h, Host, State } from '@stencil/core';

import wcShared from '@web-components/shared';

import userStore from '../../stores/store';
import { createLink } from '../../utils/utils';

@Component({
  tag: 'group-manage',
  styleUrl: 'group-manage.scss',
  shadow: true,
})
export class GroupManage {
  @State() visible = false;

  @Event() closeEvent: EventEmitter;

  private openChangeGroup(e) {
    e.stopPropagation();

    if (window['CURRENT_PROJECT'] === 'manager4') {
      window.dispatchEvent(new CustomEvent('closeSubMenuAndOpenChangeAccountWC'));
    } else {
      document.dispatchEvent(new CustomEvent('openChangeGroupModule'));
    }

    this.closeEvent.emit();
  }

  private logoToDisplay = () => {
    const currentAccount = wcShared.store.currentAccount;

    return (
      <img
        class="avatar-icon"
        src={currentAccount?.logo_square}
        alt={wcShared?.translate('Group avatar')}
      />
    );
  };

  render() {
    return (
      <Host>
        <div class="group-manage">
          <div
            class="group-manage__header"
            onClick={() => (this.visible = !this.visible)}
          >
            {this.logoToDisplay()}

            <div class="title-group">
              <div class="title-group__title">{userStore.currentGroup?.name}</div>
              <div class="title-group__subtitle">
                {wcShared?.translate('Gerer mon organisation')}
              </div>
            </div>

            <img
              src={getAssetPath('./../assets/icons/chevron-down.svg')}
              class={{ 'arrow-down': true, 'is-visible': this.visible }}
              alt="arrow-icon"
            ></img>
          </div>

          <div class={{ 'group-manage__links': true, 'is-visible': this.visible }}>
            <div
              onClick={(e: MouseEvent) =>
                wcShared.store.utils.goToLink(e, {
                  state: 'root.accounts.dashboard',
                  url: createLink('/v3/' + userStore.currentGroup?.id + '/accounts/dashboard'),
                  stateParams: true,
                })
              }
            >
              {wcShared?.translate('Compte client')}
              <img
                src={getAssetPath('./../assets/icons/chevron-right-blue-user.svg')}
                class="arrow-right"
                alt="arrow-icon"
              ></img>
            </div>

            <div
              onClick={(e: MouseEvent) =>
                wcShared.store.utils.goToLink(e, {
                  state: 'root.accounts.accounting.renewal',
                  url: createLink(
                    '/v3/' + userStore.currentGroup?.id + '/accounts/accounting/renewal',
                  ),
                  stateParams: true,
                })
              }
            >
              {wcShared?.translate('A payer')}
              <span class={{ 'bill-count': true, 'no-bill': userStore.renewsCount === 0 }}>
                {userStore.renewsCount}
              </span>
              <img
                src={getAssetPath('./../assets/icons/chevron-right-blue-user.svg')}
                class="arrow-right"
                alt="arrow-icon"
              ></img>
            </div>

            <div
              onClick={(e) => this.openChangeGroup(e)}
              class={{
                hide:
                  userStore.groups.length <= 1 ||
                  ['hosting2', 'hosting3'].includes(window['CURRENT_PROJECT']),
              }}
            >
              {wcShared?.translate("Changer d'organisation")}
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
